import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetGuessedInstanceWebsite as GetGuessedInstanceWebsiteQuery} from 'nutshell-graphql-types';

import GET_GUESSED_INSTANCE_WEBSITE from '../queries/get-guessed-instance-website.graphql';

export const useGetGuessedInstanceWebsite = (): {
    guessedInstanceWebsite: string | null | undefined;
    errorMessage: string | null | undefined;
    isLoading: boolean;
} => {
    const {
        loading: isLoading,
        data,
        error,
    } = useQuery<GetGuessedInstanceWebsiteQuery, Record<any, any>>(GET_GUESSED_INSTANCE_WEBSITE, {
        fetchPolicy: 'cache-and-network',
    });

    const sessionInstance = data ? data.sessionInstance : null;

    return {
        isLoading,
        guessedInstanceWebsite: sessionInstance && sessionInstance.guessedInstanceWebsite,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
};
